const o = [
	{ text: '', key: 'text.all', value: null },
];

const y = new Date().getFullYear();

for (let i = y; i >= y - 100; i -= 1) {
	o.push({ text: i, value: i });
}

function getBestListYearList(_this) {
	o[0].text = _this.$t(o[0].key);
	return o;
}

export default getBestListYearList;
